import { Injectable, inject, signal, computed } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { toObservable } from '@angular/core/rxjs-interop';
import { ArmyBuilderConfig } from '../config';
import { UserService } from '../userService';
import { FeatureFlag } from './models';

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
    private config = inject(ArmyBuilderConfig);
    private http = inject(HttpClient);
    private userService = inject(UserService);

    flags = signal<FeatureFlag[]>([]);
    flags$ = toObservable(this.flags);

    private get baseUrl() {
        return `${this.config.apiBaseUrl}/feature-flags`;
    }

    loadFlags() {
        this.http.get<FeatureFlag[]>(this.baseUrl).subscribe((flags) => this.flags.set(flags));
    }

    isFeatureVisible(feature: string) {
        return computed(() => {
            const flags = this.flags();
            const flag = flags.find((f) => f.feature === feature);
            if (!flag || !flag.enabled) {
                return false;
            }
            if (!flag.requiredRoles || flag.requiredRoles.length === 0) {
                return true;
            }
            const userRoles = this.userService.user()?.roles || [];
            return flag.requiredRoles.some((r) => userRoles.includes(r));
        });
    }
}
